// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__shsTy","gfeWrapper":"CalendarEvent_gfeWrapper__dBZAZ"};